import 'twin.macro';

import React, { useContext } from 'react';
import tw from 'twin.macro';

import { BodyText } from '@/components';
import { Caption } from '@/components/ui/caption/caption';
import { DeviceInfoContext } from '@/contexts/device-info-context';
import { ThemeContext } from '@/contexts/theme-context';

const styles = {
  css: ({ twStyle }) => [twStyle]
};
const ContactItem = ({ icon, text, caption, twStyle, link, iconStyle }) => {
  const { theme } = useContext(ThemeContext);
  const { isMobile } = useContext(DeviceInfoContext);
  return (
    <div tw='flex gap-2 items-center min-w-min'>
      <div
        tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-secondary rounded-full'
        css={[iconStyle, theme === 'light' && tw`bg-primary`]}
      >
        <a href={link}>{icon}</a>
      </div>
      {!isMobile && (
        <div tw='flex flex-col' css={styles.css({ twStyle })}>
          <BodyText text={text} twStyle={tw`text-s18 float-left `} css={styles.css({ twStyle })} />
          {caption && <Caption text={caption} twStyle={tw`text-inactive uppercase`} />}
        </div>
      )}
    </div>
  );
};

export { ContactItem };
